import type { VoidFunctionComponent } from 'react';

import { ActionsMenu } from './ActionsMenu';
import ProjectSummaryV2IssueScanDropdown from './ProjectSummaryV2IssueScanDropdown';

import styles from './ProjectSummaryV2Heading.module.less';

type Props = {
  projectTypeTitle: string;
  revisionLocator?: string;
  baseRevisionURL: string;
};

export const ProjectSummaryV2Heading: VoidFunctionComponent<Props> = ({
  projectTypeTitle,
  revisionLocator,
  baseRevisionURL,
}) => {
  return (
    <div className={styles.heading}>
      <div>
        <div className={styles.summaryText}>Summary</div>
        <div className={styles.projectTypeTitle}>{projectTypeTitle}</div>
      </div>
      <div className={styles.actions}>
        {revisionLocator && <ProjectSummaryV2IssueScanDropdown revisionLocator={revisionLocator} />}
        <ActionsMenu baseRevisionURL={baseRevisionURL} />
      </div>
    </div>
  );
};
